import Vue from 'vue';
import Vuex from 'vuex';

import { store as dashboard } from '@/modules/Dashboard';
import { store as auth } from '@/modules/Auth';
import { store as account } from '@/modules/Account';
import { store as info } from '@/modules/Info';
import { store as docs } from '@/modules/Docs';
import { store as home } from '@/modules/Home';
import { store as faq } from '@/modules/Faq';
import global from './modules/global';


Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
    global,
    dashboard,
    auth,
    account,
    info,
    docs,
    home,
    faq,
  },
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/shared/store/index.js